import { HistoryServiceV2 } from '@feature-hub/history-service';

export const activateHistoryServiceForNavigation = function (
  historyService: HistoryServiceV2,
  reload: () => void = window.location.reload.bind(window.location),
): ReturnType<HistoryServiceV2['history']['listen']> {
  let lastPath = historyService.history.location.pathname;

  return historyService.history.listen(() => {
    if (lastPath !== historyService.history.location.pathname) {
      window.scrollTo(0, 0);
      reload();
    }
    lastPath = historyService.history.location.pathname;
  });
};
